export const ptBr = {
  home: {
    pageTitle: "João Mago | Engenheiro de Software Full Stack Sênior",
    pageDescription:
      "João Mago é engenheiro de software full stack sênior no Brasil, com atuação remota em produtos web e mobile usando TypeScript, Node.js, React, Next.js e PostgreSQL.",
    hello: "Olá, eu sou",
    myName: "João Mago.",
    devInfo:
      "Engenheiro de Software Full Stack Sênior | Engenheiro de Software Sênior",
    locationRemote: "No Brasil · Aberto a oportunidades remotas",
    navigationLabel: "Navegação principal",
    navigationAbout: "Perfil",
    navigationSkills: "Competências",
    navigationContact: "Contato",
    languageLabel: "Idioma",
    introduction: "Perfil",
    introductionName:
      "Engenheiro Full Stack Sênior com {{years}} anos de experiência",
    introductionInfo:
      "Desenvolvo produtos web e mobile para SaaS e fintechs, atuando ao longo de todo o ciclo do produto, da arquitetura e implementação à infraestrutura, implantação e monitoramento em produção. Também tenho experiência em liderança técnica de equipes.",
    profileImageAlt: "Foto do perfil de João Mago no GitHub",
    skills: "Competências técnicas",
    coreSkills: "Stack principal",
    additionalSkills: "Tecnologias e ferramentas adicionais",
    aiDevelopmentSkills: "Desenvolvimento assistido por IA",
    contact: "Contato",
    contactPrompt: "Entre em contato ou encontre meus perfis profissionais.",
    email: "Email",
    linkedin: "Perfil no LinkedIn",
    github: "Perfil no GitHub",
  },
};
